// extracted by mini-css-extract-plugin
export default {"nameCat":"MenuSections_nameCat__nxuHR"};